'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScheduleCta = exports.ScheduleCtaUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _ReserveCta = require('./cta/ReserveCta');

var _CancelCta = require('./cta/CancelCta');

var _BuyCta = require('./cta/BuyCta');

var _SignUpCta = require('./cta/SignUpCta');

var _ReactivateCta = require('./cta/ReactivateCta');

var _JoinCta = require('./cta/JoinCta');

var _DisableCta = require('./cta/DisableCta');

var _ScheduleCta = require('./ScheduleCta.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScheduleCtaUnwrapped = exports.ScheduleCtaUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ScheduleCtaUnwrapped, _PureComponent);

  function ScheduleCtaUnwrapped() {
    var _ref;

    (0, _classCallCheck3.default)(this, ScheduleCtaUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScheduleCtaUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ScheduleCtaUnwrapped)).call.apply(_ref, [this].concat(args)));

    _this.components = {
      buy: _BuyCta.BuyCta,
      cancel: _CancelCta.CancelCta,
      disable: _DisableCta.DisableCta,
      join: _JoinCta.JoinCta,
      reactivate: _ReactivateCta.ReactivateCta,
      reserve: _ReserveCta.ReserveCta,
      signup: _SignUpCta.SignUpCta
    };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ScheduleCtaUnwrapped, [{
    key: 'handleClick',
    value: function handleClick(event) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          schedule = _props2.schedule;


      if (onClick) {
        onClick(event);
      }

      this.props.handleScheduleAction(schedule);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          props = (0, _objectWithoutProperties3.default)(_props, ['action']);

      if (!action) {
        return null;
      }

      var Component = this.components[action];
      return _react2.default.createElement(Component, (0, _extends3.default)({}, props, { onClick: this.handleClick }));
    }
  }]);
  return ScheduleCtaUnwrapped;
}(_react.PureComponent);

ScheduleCtaUnwrapped.propTypes = {
  action: _propTypes2.default.oneOf(['buy', 'cancel', 'disable', 'join', 'reactivate', 'reserve', 'signup']),
  handleScheduleAction: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  schedule: _propTypes2.default.object.isRequired
};

var ScheduleCta = exports.ScheduleCta = (0, _decorator.decorateWith)((0, _reactRedux.connect)(null, { handleScheduleAction: _ScheduleCta.handleScheduleAction }), (0, _Sagas.withSagas)({ watch: _ScheduleCta.watchScheduleCtaSagas }), (0, _decorator.withName)('ScheduleCta'))(ScheduleCtaUnwrapped);